import { render, staticRenderFns } from "./seja-uma-revenda.vue?vue&type=template&id=62d6b455&scoped=true"
import script from "./seja-uma-revenda.vue?vue&type=script&lang=js"
export * from "./seja-uma-revenda.vue?vue&type=script&lang=js"
import style0 from "./seja-uma-revenda.vue?vue&type=style&index=0&id=62d6b455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6b455",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
